// initial state
const state = {
    list: jsonData.routes,
}

// getters
const getters = {
    getProp(state) {
        return (routeName, prop) => {
            let route = state.list[routeName]

            return route && route[prop] || null
        }

    }
}

// actions
const actions = {

}

// mutations
const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
